import ReactDOM from "react-dom";
import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as IconClose } from "../../../build/images/closecircle22px.svg";
import { ReactComponent as CleanIcon } from "../../../build/images/icons/Clean.svg";
import { ReactComponent as CalendarIcon } from "../../../build/images/calendar.svg";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import "./drawer.css";
import Typography from "../../Typography";

export default function Main({
  title = "Drawer Title",
  className = "",
  isOpen,
  onClose = () => null,
  headerContent,
  children,
  footerContent,
  setCloseDrawer,
  bind,
  screen,
  filtersActive,
  cleanFilters,
  aplyFilterManager,
  filterApply,
  controlActive = true,
  applyAllFields,
  newVersion = false,
}) {
  const [isViewServices, setViewServices] = useState(false);
  const [isViewGroups, setViewGroups] = useState(false);
  const [isViewChannels, setViewChannels] = useState(false);
  const [isViewStatus, setViewStatus] = useState(false);
  const userGroups = useSelector((state) => state.groups);
  const [groupsData, setGroupsData] = useState([]);
  const [textSearchGroup, setTextSearchGroup] = useState("");
  const [textSearchService, setTextSearchService] = useState("");
  const serviceGroup = useSelector((state) => state.servicegroup);
  const [serviceData, setServiceData] = useState([]);
  const [isDomReady, setIsDomReady] = useState(false);
  const FiltersManager = useSelector((state) => state.filtersmanager);
  const dispatch = useDispatch();

  const drawerRef = useRef();

  const renderDrawer = () => {
    if (newVersion) {
      return (
        <div
          className={`drawer ${isOpen ? "drawer-visible" : ""} ${className}`}
        >
          <div
            className={`drawer-div ${
              isOpen ? "drawer-div-visible queue" : ""
            } `}
            ref={drawerRef}
          >
            <header className="drawer__div__header">
              <div className="drawer__div__header__title">{title}</div>
              <div
                className="drawer__div__header__close"
                onClick={() => {
                  setCloseDrawer();
                  onClose && onClose();
                }}
              >
                <IconClose />
              </div>
            </header>
            <div className="drawer__div__content">{children}</div>

            <footer className="drawer__div__footer">
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  alignItems: "center",
                  cursor: `${!controlActive ? "default" : "pointer"}`,
                }}
                onClick={controlActive ? cleanFilters : null}
              >
                <CleanIcon
                  className={`${
                    !controlActive ? "disabled-icon" : "clean-icon"
                  }`}
                />
                <div>
                  <Typography.H5
                    weight="400"
                    color={`${!controlActive ? "gray-125" : "red-2"}`}
                  >
                    Limpar Filtros
                  </Typography.H5>
                </div>
              </div>
              {filterApply && (
                <button
                  className="drawer__div__footer-btn-secondary"
                  onClick={() => applyAllFields()}
                >
                  Aplicar Filtros
                </button>
              )}
            </footer>
          </div>
        </div>
      );
    } else {
      return (
        <div
          className={`drawer ${isOpen ? "drawer-visible" : ""} ${className}`}
        >
          <div
            className={`drawer-div ${
              isOpen ? "drawer-div-visible filter-team" : ""
            } `}
            ref={drawerRef}
          >
            <header className="drawer__div__header">
              <div className="drawer__div__header__title">{title}</div>
              <div
                className="drawer__div__header__close"
                onClick={() => setCloseDrawer(bind)}
              >
                <IconClose />
              </div>
            </header>
            <div className="drawer__div__content">{children}</div>

            <footer className="drawer__div__footer">
              {/* <button
              className={`drawer__div__footer-btn-primary ${
                filtersActive.length > 0 ? "active-primary" : ""
              }`}
              onClick={() => cleanFilters()}
              >
              <CleanIcon />
              Limpar Filtros
                </button> */}
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  alignItems: "center",
                  cursor: `${!controlActive ? "default" : "pointer"}`,
                }}
                onClick={controlActive ? cleanFilters : null}
              >
                <CleanIcon
                  className={`${
                    !controlActive ? "disabled-icon" : "clean-icon"
                  }`}
                />
                <div>
                  <Typography.H5
                    weight="400"
                    color={`${!controlActive ? "gray-125" : "red-2"}`}
                  >
                    Limpar Filtros
                  </Typography.H5>
                </div>
              </div>
              {filterApply && (
                <button
                  className="drawer__div__footer-btn-secondary"
                  onClick={() => bind.applyAllFields()}
                >
                  Aplicar Filtros
                </button>
              )}
            </footer>
          </div>
        </div>
      );
    }
  };

  useEffect(() => {
    const portalExists = document.getElementById("drawer-portal-root");
    if (portalExists) {
      setIsDomReady(true);
    }
  }, []);

  if (!isDomReady) return null;
  // ReactDOM.createPortal
  return ReactDOM.createPortal(
    renderDrawer(),
    document.getElementById("drawer-portal-root")
  );
}
